import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
var DropDownFilterComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DropDownFilterComponent, _super);
    function DropDownFilterComponent(filterService) {
        var _this = _super.call(this, filterService) || this;
        _this.filterChange = new EventEmitter();
        return _this;
    }
    Object.defineProperty(DropDownFilterComponent.prototype, "selectedOperator", {
        get: function () {
            return this.seletedOperatorValue;
        },
        set: function (value) {
            if (value) {
                this.seletedOperatorValue = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    DropDownFilterComponent.prototype.onChange = function (value) {
        this.filterChange.emit(value);
    };
    return DropDownFilterComponent;
}(BaseFilterCellComponent));
export { DropDownFilterComponent };
